import { finish, error } from '../../../modules/audits/actions/get';
import api from '../../../api';


let result = {
    'diff': {
        'insert': [
            {
                'key': 'a.b.c.d',
                'v1': null,
                'v2': 'current value'
            },
            {
                'key': 'a.b.c.d',
                'v1': null,
                'v2': 'current value'
            }
        ],
        'update': [
            {
                'key': 'a.b.c.d',
                'v1': 'previous value',
                'v2': 'current value'
            },
            {
                'key': 'a.b.c.d',
                'v1': 'previous value',
                'v2': 'current value'
            }
        ],
        'delete': [
            {
                'key': 'a.b.c.d',
                'v1': 'previous value',
                'v2': null
            },
            {
                'key': 'a.b.c.d',
                'v1': 'previous value',
                'v2': null
            }
        ]

    }
};

export function request(dispatch, {id}) {
    let audit = result;
    dispatch(finish(id, audit));
}
